/**
 * @desc 确认/关闭报警消息(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertMessageChangeStateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/alert/message/changeState',
    data,
  });
}

export function mock(
  data: defs.AlertMessageChangeStateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/alert/message/changeState',
    data,
  });
}
